/**
 * Normalizes GET /api/event-categories into UI buckets: official vs community
 * for the four content metas, plus Custom options and officiel/non officiel radios.
 */
export function groupEventCategoriesFromApi(data) {
  const byMeta = {};
  (data || []).forEach((cat) => {
    const m = cat.metaCategoryName;
    if (!byMeta[m]) byMeta[m] = [];
    byMeta[m].push({
      label: cat.name,
      value: cat.id,
      isOfficial: !!cat.isOfficial,
      usageCount: cat.usageCount ?? 0,
    });
  });

  const sortByUsageThenName = (a, b) => {
    const u = (b.usageCount ?? 0) - (a.usageCount ?? 0);
    if (u !== 0) return u;
    return a.label.localeCompare(b.label, "fr");
  };

  const mapForLists = (arr, isOfficial) =>
    arr
      .filter((c) => c.isOfficial === isOfficial)
      .sort(sortByUsageThenName)
      .map(({ label, value, usageCount }) => ({ label, value, isOfficial, usageCount }));

  const act = byMeta["Acteur"] || [];
  const rp = byMeta["RP"] || [];
  const hrp = byMeta["HRP"] || [];
  const loc = byMeta["Localisation"] || [];
  const customRaw = byMeta["Custom"] || [];

  const customSorted = [...customRaw].sort((a, b) => {
    const u = (b.usageCount ?? 0) - (a.usageCount ?? 0);
    if (u !== 0) return u;
    return a.label.localeCompare(b.label, "fr");
  });

  return {
    actorsCategories: mapForLists(act, true),
    actorsCommunityCategories: mapForLists(act, false),
    rpCategories: mapForLists(rp, true),
    rpCommunityCategories: mapForLists(rp, false),
    hrpCategories: mapForLists(hrp, true),
    hrpCommunityCategories: mapForLists(hrp, false),
    localizationCategories: mapForLists(loc, true),
    localizationCommunityCategories: mapForLists(loc, false),
    customOptions: [
      {
        label: "Custom",
        options: customSorted.map(({ label, value }) => ({ label, value })),
      },
    ],
    officialCategories: mapForLists(byMeta["Officiel/non officiel"] || [], true).map(
      ({ label, value }) => ({ label, value })
    ),
  };
}
